/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import { router } from '../router'
import { createPinia } from 'pinia'
import { vMaska } from "maska/vue"
import VueShortkey from 'vue3-shortkey';

//** SW GW Required */
import { ScriptWorx } from 'sw-gw-gui'
import 'sw-gw-gui/style.css'

export function registerPlugins(app) {
  app
    .use(createPinia())
    .use(VueShortkey)
    .use(vuetify)
    .directive("maska", vMaska)
    

  app.use(ScriptWorx)
  .use(router(app))
}